import md5 from 'js-md5'
import base from './base64';

function signRequestParams(parameter) {
  var allKeys = [];
  parameter['time'] = parseInt(new Date().getTime() / 1000)
  for (var key in parameter) {
      if(parameter.hasOwnProperty(key)) {
          allKeys.push(key);
      }
  }
  var paramKeys = allKeys.sort(function (a, b) {
      return a.localeCompare(b);
  });
  var rawRequestValues = '';
  var rawRequestParamMap = parameter;
  paramKeys.forEach(function (key) {
      var value = rawRequestParamMap[key];
      if(value === undefined) {
          value = '';
          rawRequestParamMap[key] = value;
      }
      if(typeof(value) === 'boolean') {
          value = value + '';
          rawRequestParamMap[key] = value;
      }
      if(key === 'password') {
          value = md5(value+'Cy@mwonv2219jdwjcnsmou29&'+value);
          rawRequestParamMap[key] = value;
      }
      if(key === 'repassword') {
          value = md5(value+'Cy@mwonv2219jdwjcnsmou29&'+value);
          rawRequestParamMap[key] = value;
      }
      rawRequestValues += value;
  });
  var str = rawRequestValues + '2Y3SK8UFP9A7L';
  rawRequestParamMap['sign'] = md5(str);
  return rawRequestParamMap
}

 function getRequestParams (patrameter, commonParameters) {
  const patrameters = Object.assign(patrameter, commonParameters);
  // 打印请求参数
//   console.log("打印请求参数");
//   console.log(patrameters)
  // var patrameters = $.extend(patrameter, commonParameters);
  var rawRequest = JSON.stringify(signRequestParams(patrameters));
  // var base64Request = okBase64.encode(rawRequest);
  var base1 = new base();
  var base64Request = base1.encode(rawRequest);
  var encodeRequest = base64Request; // encodeURIComponent(base64Request);
  //todo 替换+号
  // console.info(rawRequest);
  // 打印base64后的请求
//   console.log("打印base64后的请求");
//   console.log(encodeRequest);
  return encodeRequest;
};

export default getRequestParams


// WEBPACK FOOTER //
// ./src/signParams.js